import { render, staticRenderFns } from "./nothing-here.vue?vue&type=template&id=77081ba2"
import script from "./nothing-here.vue?vue&type=script&lang=js"
export * from "./nothing-here.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports